import type {IGen} from "./interfaces/main";

export default class Is{

    private static callToString(arg:any) {
        return Object.prototype.toString.call(arg)
    }

    static $string(arg:any) {
        return Is.callToString(arg) === '[object String]';
    }

    static is(arg: any, type : any){
        if(Is.$function(type))
        {
            return arg instanceof type;
        }

        if (Is.$string(type))
        {
            return  Is.callToString(arg) === `[object ${type}]`;
        }

        return arg === type;
    }

    static $array(arg: any){
        return Is.is(arg, 'Array');
    }

    static $null(arg: any){
        return Is.is(arg, 'Null');
    }

    static $number(arg: any){
        return Is.is(arg, 'Number');
    }

    static $object(arg: any){
        return Is.is(arg, 'Object');
    }

    static $undefined(arg: any){
        return Is.is(arg, 'Undefined');
    }

    static $boolean(arg: any){
        return Is.is(arg, 'Boolean');
    }

    static $function(arg: any){
        return Is.callToString(arg) === '[object Function]';
    }

    static objectIsValid(data: IGen, rules: IGen) {
        if (!Is.$object(data)) throw new Error('The data parameter must be an Object');
        if (!Is.$object(rules)) throw new Error('The rules parameter must be an Object');

        let $response = true;
        let $keys = Object.getOwnPropertyNames(rules);

        $keys.forEach((key: string) => {
            let rule = rules[key];
            if (Is.$array(rule)) {
                if (rule.length < 1) return;
                let parcial = false;
                rule.forEach((_rule: any) => {
                    parcial = parcial || Is.is(data[key], _rule);
                });
                return $response = $response && parcial;
            }
            $response = $response && Is.is(data[key], rule);
        });
        return $response;
    }

}